import React from 'react';
import { StyledRightArrow } from './styled';

const SliderArrowRight = () => (
  <div className="slick-arrow slick-prev">
    <StyledRightArrow />
  </div>
);
export default SliderArrowRight;
